<script lang="ts" setup>
import { useStrategy } from '@/domains/esg/composables/content/useStrategy'
const { isMobile } = useBSBreakpoints()
const { committeeList } = useStrategy()
</script>

<template>
  <UiSection
    id="esg-committee"
    class="committee"
  >
    <div class="section__container">
      <div class="section__row">
        <div class="section__col">
          <UiHeader :header="$t('strategy.committee.header')" />

          <picture
            v-if="isMobile"
            class="section__picture"
          >
            <source
              media="(width < 1200px)"
              srcset="/images/strategy/benefit-systems-esg-comitee_m.webp"
            >

            <source
              media="(width >= 1200px)"
              srcset="/images/strategy/benefit-systems-esg-comitee.webp"
            >

            <img
              src="/images/strategy/benefit-systems-esg-comitee.webp"
              :alt="$t('strategy.committee.header')"
            >
          </picture>

          <p class="committee__text">
            {{ $t('strategy.committee.text') }}
          </p>

          <ul class="committee__list">
            <li
              v-for="(item, index) in committeeList"
              :key="`committee__list-${index}`"
            >
              <img
                src="/icons/lipoint.png"
                alt=""
              >

              <span class="committee__list-text">
                {{ item.item }}
              </span>
            </li>
          </ul>
        </div>

        <div
          v-if="!isMobile"
          class="section__col section__col--img"
        >
          <picture class="section__picture">
            <source
              media="(width < 1200px)"
              srcset="/images/strategy/benefit-systems-esg-comitee_m.webp"
            >
            <source
              media="(width >= 1200px)"
              srcset="/images/strategy/benefit-systems-esg-comitee.webp"
            >
            <img
              src="/images/strategy/benefit-systems-esg-comitee.webp"
              :alt="$t('strategy.committee.header')"
            >
          </picture>
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
:deep(.section) {
  margin-bottom: 0;
}

.committee {

  :deep(.ui-header) {
    margin-bottom: 3.2rem;
  }

  &__text {
    @include h10;
    margin-bottom: 5.6rem;
  }

  &__list {
    li {
      @include body-1();
      display: inline-flex;
      flex-direction: row;
      align-items: flex-start;
      margin-bottom: 3.2rem;

      img {
        margin-right: 1.6rem;
      }
    }

    &-text {
      @include body-1;
    }
  }

  .section__col--img {
    text-align: center;
  }

  .section__picture {
    img {
      margin-bottom: 3.2rem;
      border-radius: 1.6rem;
    }
  }
}

@include atM {

  .committee {
    margin-bottom: 0;

    &__text {
      @include h9;
    }
  }
}
</style>
